// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose, withProps } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withLocalization from "../hocs/withLocalization";
import withErrorState from "../hocs/withErrorState";
import withPageInfo from "../hocs/withPageInfo";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import Navigation, { NAVIGATION_HEIGHT } from "../layouts/Navigation";
import Grid from "@material-ui/core/Grid";
import IntroCard from "../emobility/IntroCard";
import { pad } from "../utils/helper";
import { HEADER_HEIGHT } from "../layouts/Header";
import withTSTopics from "../hocs/withTSTopics";
import routes from "../emobility/routes";
import BannerCard from "./BannerCard";
import withTSTopic from "../hocs/withTSTopic";
import EMobilityContent from "../emobility/EMobilityContent";

const styles = (theme) => ({
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        paddingBottom: 20,
    },
    heading: {
        marginTop: 24,
        marginBottom: 32,
        "& > a": {
            position: "absolute",
            top: `-${HEADER_HEIGHT + NAVIGATION_HEIGHT}px`,
        },
    },
});

const TransportSolutions = ({ classes, tSTopics, tSTopic }) => {
    return (
        <React.Fragment>
            <Navigation />
            <div
                style={{
                    flex: "1 0 auto",
                    background: "#fafafa",
                    paddingTop: NAVIGATION_HEIGHT,
                }}
            >
                <BannerCard topic={tSTopic} />
                <div className={classes.sectionsWrapperStyle} style={{ marginTop: 16 }}>
                    <div className={classes.containerStyle}>
                        <Grid container>
                            <Grid item xs md={8}>
                                {tSTopic && tSTopic.tsContents && (
                                    <EMobilityContent eMobilityContents={tSTopic.tsContents} number={tSTopic.order} />
                                )}
                            </Grid>
                        </Grid>
                        <div>
                            <Grid container spacing={24}>
                                {tSTopics &&
                                    tSTopics
                                        .filter((topic) => !topic.banner)
                                        .map((topic) => (
                                            <IntroCard
                                                key={topic.id}
                                                number={pad(topic.order || 0, 2)}
                                                title={topic.title}
                                                disabled={!topic.active}
                                                image={topic.thumbnail}
                                                intro={topic.intro}
                                                slug={topic.slug}
                                                baseRoute={routes.transportSolutions}
                                                light
                                            />
                                        ))}
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default compose(
    withProps(({ match: { params } }) => {
        return {
            slug: "transport-solutions",
        };
    }),
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    withErrorState,
    withPageInfo,
    withRouter,
    withTSTopic(),
    withTSTopics(),
    withStyles(sharedComponentStyles),
    withStyles(styles)
)(TransportSolutions);



// WEBPACK FOOTER //
// ./src/transportsolutions/TransportSolutions.js